import { t } from '../i18n/translate';

// Custom error class for authentication errors
export class AuthenticationError extends Error {
  constructor(message?: string) {
    super(message ?? t('auth.error.session_expired'));
    this.name = 'AuthenticationError';
    Object.setPrototypeOf(this, AuthenticationError.prototype);
  }
}

// Helper function to check if an error is an authentication error
export function isAuthenticationError(error: any): boolean {
  return (
    error instanceof AuthenticationError ||
    error?.name === 'AuthenticationError' ||
    (error?.message &&
      (error.message.includes('401') ||
        error.message.includes('Token expired') ||
        error.message.includes('Invalid token') ||
        error.message.includes('Not logged in') ||
        error.message.includes('No authentication token')))
  );
}

// Helper function to extract auth error message from API response
export function extractAuthError(response: Response, errorText: string): string {
  if (response.status === 401) {
    try {
      const errorData = JSON.parse(errorText);
      if (errorData.detail) {
        if (errorData.detail.includes('expired')) {
          return t('auth.error.session_expired');
        }
        if (errorData.detail.includes('Invalid token')) {
          return t('auth.error.session_invalid');
        }
        return t('auth.error.please_log_in');
      }
    } catch {
      // If JSON parsing fails, use default message
    }
    return t('auth.error.session_expired');
  }
  return errorText;
}
